import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import "./DistrictEngagement.scss";
import engagementJSON from "../../assets/data/engagement.json";
import axios from "axios";
import Cookies from "universal-cookie";
import { CAMS_URL, FETCH_URL } from "../../constants/ServerLinks";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import downtownImage from "../../assets/images/city1-lowOpacityblue-01.png"
import jacobsHillImage from "../../assets/images/jacobs_hill-01.png"
import mosesGulchImage from "../../assets/images/moses_gulch-02.png"
import corbusvileImage from "../../assets/images/corbusville-01.png"
import howardGardensImage from "../../assets/images/howard_gardens-01.png"




class DistrictEngagement extends Component {
  constructor(props) {
    super(props);
    this.cookies = new Cookies();
    this.city_name = this.cookies.get("city_name");
    this.city_id = this.cookies.get("city_id");
    this.student_is_manager = this.cookies.get("student_is_manager");

    this.fetchURL = FETCH_URL;
    this.camsURL = CAMS_URL;

    this.state = {
      districtEngagementData: engagementJSON,
      policyHeader: props.policyHeader,
      engagementDefaultValue: sessionStorage.getItem(
        `${props.districtName}/${this.subPolicy}`
      ),
      disabledButton: false,
      Inform: 0,
      InformTarget: 0,
      InformLock: false,
      InformMax: 3,
      InformMaxReached: false,
      InformObj: {},
      InformSubmitted: 0,
      Consult: 0,
      ConsultTarget: 0,
      ConsultLock: true,
      ConsultDisabled: true,
      ConsultMax: 10,
      ConsultMaxReached: false,
      ConsultObj: {},
      ConsultSubmitted: 0,
      Involve: 0,
      InvolveTarget: 0,
      InvolveLock: true,
      InvolveDisabled: true,
      InvolveMax: 10,
      InvolveMaxReached: false,
      InvolveObj: {},
      InvolveSubmitted: 0,
      Collaborate: 0,
      CollaborateTarget: 0,
      CollaborateLock: true,
      CollaborateDisabled: true,
      CollaborateMax: 20,
      CollaborateObj: {},
      CollaborateMaxReached: false,
      CollaborateSubmitted: 0,
      categoryTotal: 0,
      suspendButton: false,
    };
  }
  

  getEngagementSelections = () => {
    
    const cityName = this.city_name;
    this.eventSource = new EventSource(
      this.fetchURL + "/" + cityName + "/selections/"
    );
    this.eventSource.onmessage = e => {
      console.group("DistrictEngagement:componentDidMount")
      console.log("Event Source Message received")
      this.setState({
        eventSourceMessage: JSON.parse(e.data).data
      });
      for (let item in this.state.eventSourceMessage) {
        // console.log(item);
        sessionStorage.setItem(item, this.state.eventSourceMessage[item]);
      }
      // this.props.setEngagement(
      //   sessionStorage.getItem("currentEngagement"),
      //   sessionStorage.getItem("totalEngagement")
      // );
    

    // console.log(sessionStorage.getItem("InformMaxReached"));
    // console.log(typeof sessionStorage.getItem("InformMaxReached"));


    let suspendedObj = {};

    if (sessionStorage.getItem("InformMaxReached") === "true") {
      console.log("Max Reached");
      suspendedObj["InformMaxReached"] = true;
    } else if (
      sessionStorage.getItem("InformMaxReached") === "false" ||
      !sessionStorage.getItem("InformMaxReached")
    ) {
      console.log("Max Not Reached");
      suspendedObj["InformMaxReached"] = false;
    }

    if (sessionStorage.getItem("ConsultMaxReached") === "true") {
      suspendedObj["ConsultMaxReached"] = true;
    } else if (
      sessionStorage.getItem("ConsultMaxReached") === "false" ||
      !sessionStorage.getItem("ConsultMaxReached")
    ) {
      suspendedObj["ConsultMaxReached"] = false;
    }

    if (sessionStorage.getItem("InvolveMaxReached") === "true") {
      suspendedObj["InvolveMaxReached"] = true;
    } else if (
      sessionStorage.getItem("InvolveMaxReached") === "false" ||
      !sessionStorage.getItem("InvolveMaxReached")
    ) {
      suspendedObj["InvolveMaxReached"] = false;
    }

    if (sessionStorage.getItem("CollaborateMaxReached") === "true") {
      suspendedObj["CollaborateMaxReached"] = true;
    } else if (
      sessionStorage.getItem("CollaborateMaxReached") === "false" ||
      !sessionStorage.getItem("CollaborateMaxReached")
    ) {
      suspendedObj["CollaborateMaxReached"] = false;
    }
    let falseCounter = 0;
    for (let item in suspendedObj) {
      if (suspendedObj[item] === true) {
        // console.log(suspendedObj);
        this.setState({
          suspendButton: true
        });
      }

      if (suspendedObj[item] === false) {
        // console.log(suspendedObj);
        falseCounter++;
        // console.log(falseCounter);
      }
      // console.log(falseCounter);
      if (falseCounter === 4) {
        this.setState({
          suspendButton: false
        });
      }
    }
  };
  console.groupEnd()
  };

  setPolicyHeader = () => {
    console.groupCollapsed("DistrictEngagement:setPolicyHeader")
    const policyHdrUrl = window.location.href.split("/")[6];
    if (policyHdrUrl) {
      this.setState({
        policyHeader:
          policyHdrUrl.charAt(0).toUpperCase() +
          window.location.href.split("/")[6].substring(1)
      });
    }
    console.groupEnd()
  };

  lockCheck = () => {
    console.groupCollapsed("DistrictEngagement:lockCheck")
    if (this.state.Inform >= this.state.InformTarget) {
      // console.log(
      //   `This is the counter: ${this.state.Inform} and this is the target: ${this.state.InformTarget}`
      // );
      this.setState({
        ConsultLock: false
      });
    } else if (this.state.Inform < this.state.InformTarget) {
      // console.log(
      //   `This is the counter: ${this.state.Inform} and this is the target: ${this.state.InformTarget}`
      // );
      this.setState({
        ConsultLock: true
      });
    }

    if (
      this.state.Inform >= this.state.InformTarget &&
      this.state.Consult >= this.state.ConsultTarget
    ) {
      // console.log(
      //   `This is the Inform counter: ${this.state.Inform} and this is the Inform target: ${this.state.InformTarget} This is the Consult counter: ${this.state.Consult} and this is the Consult target: ${this.state.ConsultTarget}`
      // );
      this.setState({
        InvolveLock: false
      });
    } else if (
      this.state.Inform >= this.state.InformTarget &&
      this.state.Consult < this.state.ConsultTarget
    ) {
      // console.log(
      //   `This is the Inform counter: ${this.state.Inform} and this is the Inform target: ${this.state.InformTarget} This is the Consult counter: ${this.state.Consult} and this is the Consult target: ${this.state.ConsultTarget}`
      // );
      this.setState({
        InvolveLock: true
      });
    }

    if (
      this.state.Inform >= this.state.InformTarget &&
      this.state.Consult >= this.state.ConsultTarget &&
      this.state.Involve >= this.state.InvolveTarget
    ) {
      this.setState({
        CollaborateLock: false
      });
    } else if (
      this.state.Inform >= this.state.InformTarget &&
      this.state.Consult >= this.state.ConsultTarget &&
      this.state.Involve < this.state.InvolveTarget
    ) {
      this.setState({
        CollaborateLock: true
      });
    }
    console.groupEnd()
  };

  setDefaults = () => {
    console.groupCollapsed("DistrictEngagement:setDefaults")
    let targetsFromJSON = this.state.districtEngagementData;

    for (let i = 0; i < targetsFromJSON.length; i++) {
      if (sessionStorage.getItem(`${targetsFromJSON[i].name}MaxButton`)) {
        this.setState({
          [`${targetsFromJSON[i].name}MaxButton`]: sessionStorage.getItem(
            `${targetsFromJSON[i].name}MaxButton`
          )
        });
      } else {
        this.setState({
          [`${targetsFromJSON[i].name}MaxButton`]: null
        });
      }
      // console.log(
      //   sessionStorage.getItem(`${targetsFromJSON[i].name}MaxReached`)
      // );
      if (
        sessionStorage.getItem(`${targetsFromJSON[i].name}MaxReached`) ===
        "true"
      ) {
        // console.log("Max is true");
        // this.setState({
        //   [`${targetsFromJSON[i].name}MaxReached`]: true
        // });
      } else if (
        !sessionStorage.getItem(`${targetsFromJSON[i].name}MaxReached`) ||
        sessionStorage.getItem(`${targetsFromJSON[i].name}MaxReached`) ===
          "false"
      ) {
        // console.log("Max is out");
        // this.setState({
        //   [`${targetsFromJSON[i].name}MaxReached`]: false
        // });
      }
      let total = 0;
      // console.log(targetsFromJSON[i])
      // console.log(targetsFromJSON[i].name)
      // console.log(targetsFromJSON[i].parameters)

      //Set Category Objects
      if (sessionStorage.getItem(`${targetsFromJSON[i].name}Obj`)) {
        // console.log(sessionStorage.getItem(`${targetsFromJSON[i].name}Obj`))
        this.setState({
          [`${targetsFromJSON[i].name}Obj`]: JSON.parse(
            sessionStorage.getItem(`${targetsFromJSON[i].name}Obj`)
          )
        });
        for (let key in JSON.parse(
          sessionStorage.getItem(`${targetsFromJSON[i].name}Obj`)
        )) {
          // console.log([key][0]);
          // console.log(
          //   JSON.parse(sessionStorage.getItem(`${targetsFromJSON[i].name}Obj`))[
          //     key
          //   ]
          // );
          if (
            !JSON.parse(
              sessionStorage.getItem(`${targetsFromJSON[i].name}Obj`)
            )[key]
          ) {
            sessionStorage.setItem(`${[key][0]}`, false);
          }

          //---THIS BELOW FUNCTION IS TO SET THE CURRENT CREDITS WHEN THE PAGE RELOADS -- WIP//

          // this.props.engagementFunc([key][0], -Math.abs(JSON.parse(sessionStorage.getItem(`${targetsFromJSON[i].name}Obj`))[key]))
        }
      }

      //Set Toggled Values
      for (let item in targetsFromJSON[i].parameters) {
        //Compare with session storage to see if
        let formattedName = Object.values(
          targetsFromJSON[i].parameters[item]
        )[0]
          .replace(" ", "_")
          .toLowerCase();
        // console.log(formattedName)
        if (sessionStorage.getItem(`${formattedName}`)) {
          // console.log(`${formattedName} is present in storage...and...`)
          // console.log(`Here is its value: ${sessionStorage.getItem(formattedName)} and type ${typeof(sessionStorage.getItem(formattedName))}`)
          if (sessionStorage.getItem(`${formattedName}`) === "true") {
            // console.log(`${formattedName} was labled as true`)
            this.setState({
              [formattedName]: true
            });
          } else if (sessionStorage.getItem(`${formattedName}`) === "false") {
            // console.log(`${formattedName} was labled as false`)
            this.setState({
              [formattedName]: false
            });
          }
        } else if (!sessionStorage.getItem(`${formattedName}`)) {
          // console.log(`Nothing present in storage for ${formattedName}`)
          this.setState({
            [formattedName]: false
          });
        }

        total += Object.values(targetsFromJSON[i].parameters[item])[1];
        sessionStorage.setItem(
          `${Object.values(targetsFromJSON[i].parameters[item])[0]}`,
          `${total}`
        );
      }
      // console.log(total)
      if (sessionStorage.getItem(targetsFromJSON[i].name)) {
        this.setState({
          [`${targetsFromJSON[i].name}`]: sessionStorage.getItem(
            targetsFromJSON[i].name
          )
        });
      }
      this.setState({
        [`${targetsFromJSON[i].name}Target`]: total
      });
    }
    console.log(this.props.engagementData)
    if(this.props.engagementData) {
      //set locks and counters if present
    }
    console.groupEnd()
  };

  componentDidMount() {
    console.groupCollapsed("DistrictEngagement:componentDidMount")
    // this.getEngagementSelections();
    // setInterval( () => {
    //   this.eventSource.close();
    //   this.getEngagementSelections()
    // }, 10000)

    // this.setPolicyHeader();
    this.lockCheck();
    // console.log(this.student_is_manager);


    if (this.student_is_manager === "false") {
      // console.log("Inside False")
      this.setState({
        disabledButton: true
      });
    } else if (this.student_is_manager === "true") {
      // console.log("Inside True")
      this.setState({
        disabledButton: false
      });
    }
    let suspendedObj = {};

    if (sessionStorage.getItem("InformMaxReached") === "true") {
      // console.log("Max Reached");
      suspendedObj["InformMaxReached"] = true;
    } else if (
      sessionStorage.getItem("InformMaxReached") === "false" ||
      !sessionStorage.getItem("InformMaxReached")
    ) {
      // console.log("Max Not Reached");
      suspendedObj["InformMaxReached"] = false;
    }

    if (sessionStorage.getItem("ConsultMaxReached") === "true") {
      suspendedObj["ConsultMaxReached"] = true;
    } else if (
      sessionStorage.getItem("ConsultMaxReached") === "false" ||
      !sessionStorage.getItem("ConsultMaxReached")
    ) {
      suspendedObj["ConsultMaxReached"] = false;
    }

    if (sessionStorage.getItem("InvolveMaxReached") === "true") {
      suspendedObj["InvolveMaxReached"] = true;
    } else if (
      sessionStorage.getItem("InvolveMaxReached") === "false" ||
      !sessionStorage.getItem("InvolveMaxReached")
    ) {
      suspendedObj["InvolveMaxReached"] = false;
    }

    if (sessionStorage.getItem("CollaborateMaxReached") === "true") {
      suspendedObj["CollaborateMaxReached"] = true;
    } else if (
      sessionStorage.getItem("CollaborateMaxReached") === "false" ||
      !sessionStorage.getItem("CollaborateMaxReached")
    ) {
      suspendedObj["CollaborateMaxReached"] = false;
    }
    let falseCounter = 0;
    for (let item in suspendedObj) {
      if (suspendedObj[item] === true) {
        console.log(suspendedObj);
        this.setState({
          suspendButton: true
        });
      }

      if (suspendedObj[item] === false) {
        // console.log(suspendedObj);
        falseCounter++;
        // console.log(falseCounter);
      }
      // console.log(falseCounter);
      if (falseCounter === 4) {
        this.setState({
          suspendButton: false
        });
      }
    }
    console.groupEnd()
  }

  // componentWillMount() {
  //   this.setDefaults();
  // }

  // componentWillUnmount() {
  //   this.eventSource.close();
  // }

  // componentDidUpdate(prevProps, nextProps) {
  //   // console.groupCollapsed("DistrictEngagement:componentDidUpdate")
  //   if (this.props.InformObj !== prevProps.InformObj) {
  //     // console.log("Something changed");
  //     this.setState({
  //       InformSubmitted: this.props.InformSubmitted,
  //       ConsultSubmitted: this.props.ConsultSubmitted,
  //       InvolveSubmitted: this.props.InvolveSubmitted,
  //       CollaborateSubmitted: this.props.CollaborateSubmitted
  //     });
  //     this.setDefaults();
  //     console.log(
  //       `This is in session storage: ${sessionStorage.getItem(
  //         "engageObj"
  //       )} This is from props: ${JSON.stringify(
  //         this.props.engageObj
  //       )} and this is previous props ${JSON.stringify(
  //         prevProps.engageObj
  //       )} and this is next props: ${JSON.stringify(nextProps.engageObj)}`
  //     );
  //     if (sessionStorage.getItem("Inform") >= this.state.InformTarget) {
  //       // console.log(
  //       //   `This is the counter: ${sessionStorage.getItem(
  //       //     "Inform"
  //       //   )} and this is the target: ${this.state.InformTarget}`
  //       // );
  //       this.setState({
  //         ConsultLock: false
  //       });
  //     } else if (sessionStorage.getItem("Inform") < this.state.InformTarget) {
  //       // console.log(
  //       //   `This is the counter: ${sessionStorage.getItem(
  //       //     "Inform"
  //       //   )} and this is the target: ${this.state.InformTarget}`
  //       // );
  //       this.setState({
  //         ConsultLock: true
  //       });
  //     }
  //     if (
  //       sessionStorage.getItem("Inform") >= this.state.InformTarget &&
  //       sessionStorage.getItem("Consult") >= this.state.ConsultTarget
  //     ) {
  //       console.log(
  //         `This is the Inform counter: ${sessionStorage.getItem(
  //           "Inform"
  //         )} and this is the Inform target: ${
  //           this.state.InformTarget
  //         } This is the Consult counter: ${sessionStorage.getItem(
  //           "Consult"
  //         )} and this is the Consult target: ${this.state.ConsultTarget}`
  //       );
  //       this.setState({
  //         InvolveLock: false
  //       });
  //     } else if (
  //       sessionStorage.getItem("Inform") >= this.state.InformTarget &&
  //       sessionStorage.getItem("Consult") < this.state.ConsultTarget
  //     ) {
  //       console.log(
  //         `This is the Inform counter: ${sessionStorage.getItem(
  //           "Inform"
  //         )} and this is the Inform target: ${
  //           this.state.InformTarget
  //         } This is the Consult counter: ${sessionStorage.getItem(
  //           "Consult"
  //         )} and this is the Consult target: ${this.state.ConsultTarget}`
  //       );
  //       this.setState({
  //         InvolveLock: true
  //       });
  //     }
  //     if (
  //       sessionStorage.getItem("Inform") >= this.state.InformTarget &&
  //       sessionStorage.getItem("Consult") >= this.state.ConsultTarget &&
  //       sessionStorage.getItem("Involve") >= this.state.InvolveTarget
  //     ) {
  //       this.setState({
  //         CollaborateLock: false
  //       });
  //     } else if (
  //       sessionStorage.getItem("Inform") >= this.state.InformTarget &&
  //       sessionStorage.getItem("Consult") >= this.state.ConsultTarget &&
  //       sessionStorage.getItem("Involve") < this.state.InvolveTarget
  //     ) {
  //       this.setState({
  //         CollaborateLock: true
  //       });
  //     }
  //   }

  //   if (this.props.ConsultObj !== prevProps.ConsultObj) {
  //     console.log("Something changed");
  //     this.setDefaults();
  //     if (sessionStorage.getItem("Inform") >= this.state.InformTarget) {
  //       console.log(
  //         `This is the counter: ${sessionStorage.getItem(
  //           "Inform"
  //         )} and this is the target: ${this.state.InformTarget}`
  //       );
  //       this.setState({
  //         ConsultLock: false
  //       });
  //     } else if (sessionStorage.getItem("Inform") < this.state.InformTarget) {
  //       console.log(
  //         `This is the counter: ${sessionStorage.getItem(
  //           "Inform"
  //         )} and this is the target: ${this.state.InformTarget}`
  //       );
  //       this.setState({
  //         ConsultLock: true
  //       });
  //     }
  //     if (
  //       sessionStorage.getItem("Inform") >= this.state.InformTarget &&
  //       sessionStorage.getItem("Consult") >= this.state.ConsultTarget
  //     ) {
  //       console.log(
  //         `This is the Inform counter: ${sessionStorage.getItem(
  //           "Inform"
  //         )} and this is the Inform target: ${
  //           this.state.InformTarget
  //         } This is the Consult counter: ${sessionStorage.getItem(
  //           "Consult"
  //         )} and this is the Consult target: ${this.state.ConsultTarget}`
  //       );
  //       this.setState({
  //         InvolveLock: false
  //       });
  //     } else if (
  //       sessionStorage.getItem("Inform") >= this.state.InformTarget &&
  //       sessionStorage.getItem("Consult") < this.state.ConsultTarget
  //     ) {
  //       console.log(
  //         `This is the Inform counter: ${sessionStorage.getItem(
  //           "Inform"
  //         )} and this is the Inform target: ${
  //           this.state.InformTarget
  //         } This is the Consult counter: ${sessionStorage.getItem(
  //           "Consult"
  //         )} and this is the Consult target: ${this.state.ConsultTarget}`
  //       );
  //       this.setState({
  //         InvolveLock: true
  //       });
  //     }
  //     if (
  //       sessionStorage.getItem("Inform") >= this.state.InformTarget &&
  //       sessionStorage.getItem("Consult") >= this.state.ConsultTarget &&
  //       sessionStorage.getItem("Involve") >= this.state.InvolveTarget
  //     ) {
  //       this.setState({
  //         CollaborateLock: false
  //       });
  //     } else if (
  //       sessionStorage.getItem("Inform") >= this.state.InformTarget &&
  //       sessionStorage.getItem("Consult") >= this.state.ConsultTarget &&
  //       sessionStorage.getItem("Involve") < this.state.InvolveTarget
  //     ) {
  //       this.setState({
  //         CollaborateLock: true
  //       });
  //     }
  //   }

  //   if (this.props.InvolveObj !== prevProps.InvolveObj) {
  //     console.log("Something changed");
  //     this.setDefaults();
  //     if (sessionStorage.getItem("Inform") >= this.state.InformTarget) {
  //       console.log(
  //         `This is the counter: ${sessionStorage.getItem(
  //           "Inform"
  //         )} and this is the target: ${this.state.InformTarget}`
  //       );
  //       this.setState({
  //         ConsultLock: false
  //       });
  //     } else if (sessionStorage.getItem("Inform") < this.state.InformTarget) {
  //       console.log(
  //         `This is the counter: ${sessionStorage.getItem(
  //           "Inform"
  //         )} and this is the target: ${this.state.InformTarget}`
  //       );
  //       this.setState({
  //         ConsultLock: true
  //       });
  //     }
  //     if (
  //       sessionStorage.getItem("Inform") >= this.state.InformTarget &&
  //       sessionStorage.getItem("Consult") >= this.state.ConsultTarget
  //     ) {
  //       console.log(
  //         `This is the Inform counter: ${sessionStorage.getItem(
  //           "Inform"
  //         )} and this is the Inform target: ${
  //           this.state.InformTarget
  //         } This is the Consult counter: ${sessionStorage.getItem(
  //           "Consult"
  //         )} and this is the Consult target: ${this.state.ConsultTarget}`
  //       );
  //       this.setState({
  //         InvolveLock: false
  //       });
  //     } else if (
  //       sessionStorage.getItem("Inform") >= this.state.InformTarget &&
  //       sessionStorage.getItem("Consult") < this.state.ConsultTarget
  //     ) {
  //       console.log(
  //         `This is the Inform counter: ${sessionStorage.getItem(
  //           "Inform"
  //         )} and this is the Inform target: ${
  //           this.state.InformTarget
  //         } This is the Consult counter: ${sessionStorage.getItem(
  //           "Consult"
  //         )} and this is the Consult target: ${this.state.ConsultTarget}`
  //       );
  //       this.setState({
  //         InvolveLock: true
  //       });
  //     }
  //     if (
  //       sessionStorage.getItem("Inform") >= this.state.InformTarget &&
  //       sessionStorage.getItem("Consult") >= this.state.ConsultTarget &&
  //       sessionStorage.getItem("Involve") >= this.state.InvolveTarget
  //     ) {
  //       this.setState({
  //         CollaborateLock: false
  //       });
  //     } else if (
  //       sessionStorage.getItem("Inform") >= this.state.InformTarget &&
  //       sessionStorage.getItem("Consult") >= this.state.ConsultTarget &&
  //       sessionStorage.getItem("Involve") < this.state.InvolveTarget
  //     ) {
  //       this.setState({
  //         CollaborateLock: true
  //       });
  //     }
  //   }

  //   if (this.props.CollaborateObj !== prevProps.CollaborateObj) {
  //     console.log("Something changed");
  //     this.setDefaults();
  //     if (sessionStorage.getItem("Inform") >= this.state.InformTarget) {
  //       console.log(
  //         `This is the counter: ${sessionStorage.getItem(
  //           "Inform"
  //         )} and this is the target: ${this.state.InformTarget}`
  //       );
  //       this.setState({
  //         ConsultLock: false
  //       });
  //     } else if (sessionStorage.getItem("Inform") < this.state.InformTarget) {
  //       console.log(
  //         `This is the counter: ${sessionStorage.getItem(
  //           "Inform"
  //         )} and this is the target: ${this.state.InformTarget}`
  //       );
  //       this.setState({
  //         ConsultLock: true
  //       });
  //     }
  //     if (
  //       sessionStorage.getItem("Inform") >= this.state.InformTarget &&
  //       sessionStorage.getItem("Consult") >= this.state.ConsultTarget
  //     ) {
  //       console.log(
  //         `This is the Inform counter: ${sessionStorage.getItem(
  //           "Inform"
  //         )} and this is the Inform target: ${
  //           this.state.InformTarget
  //         } This is the Consult counter: ${sessionStorage.getItem(
  //           "Consult"
  //         )} and this is the Consult target: ${this.state.ConsultTarget}`
  //       );
  //       this.setState({
  //         InvolveLock: false
  //       });
  //     } else if (
  //       sessionStorage.getItem("Inform") >= this.state.InformTarget &&
  //       sessionStorage.getItem("Consult") < this.state.ConsultTarget
  //     ) {
  //       console.log(
  //         `This is the Inform counter: ${sessionStorage.getItem(
  //           "Inform"
  //         )} and this is the Inform target: ${
  //           this.state.InformTarget
  //         } This is the Consult counter: ${sessionStorage.getItem(
  //           "Consult"
  //         )} and this is the Consult target: ${this.state.ConsultTarget}`
  //       );
  //       this.setState({
  //         InvolveLock: true
  //       });
  //     }
  //     if (
  //       sessionStorage.getItem("Inform") >= this.state.InformTarget &&
  //       sessionStorage.getItem("Consult") >= this.state.ConsultTarget &&
  //       sessionStorage.getItem("Involve") >= this.state.InvolveTarget
  //     ) {
  //       this.setState({
  //         CollaborateLock: false
  //       });
  //     } else if (
  //       sessionStorage.getItem("Inform") >= this.state.InformTarget &&
  //       sessionStorage.getItem("Consult") >= this.state.ConsultTarget &&
  //       sessionStorage.getItem("Involve") < this.state.InvolveTarget
  //     ) {
  //       this.setState({
  //         CollaborateLock: true
  //       });
  //     }
  //   }
  //   if(this.props.engagementData !== prevProps.engagementData){
  //     console.log(this.props.engagementData)
  //   }
  //   // console.groupEnd()
  // }

  runSelections = () => {
    axios
      .post(this.fetchURL + "/api/v1/selections/", {
        selections: sessionStorage,
        city_name: this.city_name
      })
      .then(response => {
        this.setState({ startRequestSent: false });
        if (response.data.success) {
          console.group("Selections Routing Test Started");
          console.log("Test Successfull!");
          console.log(response.data.data);
          console.groupEnd();
        }
      })
      //     this.setState({
      //       snackOpen: true,
      //       snackMsg: response.data.message,
      //       snackType: "snack-success",
      //       snackAutoHideDuration: 5000
      //     });

      //     // added to update objectives after starting the scenario
      //     window.location.reload();
      //   } else {
      //     console.log(response.data.message);
      //     this.setState({
      //       snackOpen: true,
      //       snackMsg: response.data.message,
      //       snackType: "snack-error",
      //       snackAutoHideDuration: null
      //     });
      //   }
      // })
      .catch(error => {
        console.log(error.response);
        this.setState({ startRequestSent: false });
        this.setState({
          snackOpen: true,
          snackMsg: "Something went wrong. Please try again later.",
          snackType: "snack-error",
          snackAutoHideDuration: 5000
        });
      });

  }

  onSelectHandler = async (e) => {
    console.groupCollapsed("DistrictEngagement:onSelectHandler")
    e.preventDefault();

    let diff = -Math.abs(e.target.getAttribute("engageval"));
    // console.log(diff)
    let formattedName = e.target
      .getAttribute("name")
      .replace(" ", "_")
      .toLowerCase();
    let value = e.target.getAttribute("engageVal");
    let category = this.state.subPolicy;
    let categoryObj = {};
    let categoryTotal = 0;
    
    
    this.setState({
      engagementDefaultValue: e.target.value
      
    });

    if (this.state[formattedName]) {
      // console.log(this.state[category]);
      categoryObj = this.state[`${category}Obj`];
      if (this.state[formattedName] === false) {
        // console.log(`${formattedName} is false`);
        this.setState({
          [category]: (this.state[category] += parseInt(value))
        });
        if (this.state[category]) {
          categoryTotal = parseInt(this.state[category]);
        } else {
          categoryTotal = 0;
        }
        categoryObj[formattedName] = value;
        // console.log(this.state.fact_sheets);
        // console.log(categoryObj);
        for (let item in categoryObj) {
          // console.log("Inside the for loop")
          // console.log(categoryObj[item])
          // console.log(categoryTotal)
          categoryTotal += parseInt(categoryObj[item]);
          // console.log("Inform in if for loop: " + this.state.Inform)
          // this.setState({categoryTotal: categoryTotal, [category]: categoryTotal})
          // this.lockCheck()
          if (this.state.categoryTotal > this.state[`${category}Max`]) {
            // console.log(`This is the total for ${category}:  ` + categoryTotal)
            console.log(categoryObj);
            this.setState({
              [`${category}MaxReached`]: true
            });
          } else {
            console.log(categoryObj);
            this.setState({
              [`${category}MaxReached`]: false
            });
          }
        }
        // console.log(categoryTotal)
        this.setState({
          [formattedName]: true,
          [`${category}Obj`]: categoryObj,
          categoryTotal: categoryTotal,
          [category]: categoryTotal
        });
        sessionStorage.setItem(`${category}Obj`, JSON.stringify(categoryObj));
        sessionStorage.setItem(formattedName, true);
        sessionStorage.setItem(category, categoryTotal);
        await this.props.engagementFunc(formattedName, diff);
        // console.log("Inform outside the for loop: " + this.state.Inform)
      } else if (this.state[formattedName] === true) {
        // console.log(`${formattedName} is true: ` + this.state[formattedName]);
        this.setState({
          [category]: (this.state[category] -= parseInt(value))
        });

        categoryTotal = 0;

        categoryObj = this.state[`${category}Obj`];
        categoryObj[formattedName] = 0;
        this.setState({
          [formattedName]: false
        });
        sessionStorage.setItem(formattedName, false);
        await this.props.engagementFunc(formattedName, 0);

        for (let item in categoryObj) {
          // console.log(categoryObj);
          // console.log(categoryObj[item]);
          categoryTotal += parseInt(categoryObj[item]);
          // console.log(categoryTotal);
          // console.log("Inform in if for loop: " + this.state.Inform);
          if (categoryTotal > this.state[`${category}Max`]) {
            // console.log(`This is the total for ${category}:  ` + categoryTotal);
            console.log(categoryObj);
            this.setState({
              [`${category}MaxReached`]: true
            });
            sessionStorage.setItem(`${category}MaxReached`, true);
            let comparoKey = 0;
            let comparoKeyName;
            for (let key in categoryObj) {
              if (parseInt(categoryObj[key]) > comparoKey) {
                console.log(key);
                comparoKey = parseInt(categoryObj[key]);
                comparoKeyName = key;
              } else if (parseInt(categoryObj[key]) === comparoKey) {
                console.log("equal");
                console.log(key);
                comparoKey = parseInt(categoryObj[key]);
                comparoKeyName = key;
              }
              console.log(comparoKeyName);
              let unFormattedText = comparoKeyName
                .split("_")
                .map(s => s.charAt(0).toUpperCase() + s.substring(1))
                .join(" ");
              console.log(unFormattedText);
              sessionStorage.setItem(`${category}MaxButton`, unFormattedText);
              this.setState({
                [`${category}MaxButton`]: unFormattedText
              });
            }
          } else {
            console.log(categoryObj);
            this.setState({
              [`${category}MaxReached`]: false,
              [`${category}MaxButton`]: null
            });
            sessionStorage.setItem(`${category}MaxReached`, false);
            sessionStorage.setItem(`${category}MaxButton`, null);
          }
        }
        // console.log(categoryTotal);
        // console.log("Inform out of for loop: " + this.state.Inform);
        this.setState({
          [`${category}Obj`]: categoryObj,
          categoryTotal: categoryTotal,
          [category]: categoryTotal
        });
        sessionStorage.setItem(category, categoryTotal);
        if (!isNaN(parseInt(sessionStorage.getItem(`${category}Submitted`)))) {
          let newTotal =
            categoryTotal +
            parseInt(sessionStorage.getItem(`${category}Submitted`));
          this.setState({
            [category]: newTotal
          });
          sessionStorage.setItem(category, newTotal);
          // console.log("Total of running and existing: " + newTotal)
        }

        sessionStorage.setItem(`${category}Obj`, JSON.stringify(categoryObj));
        await this.lockCheck();
      }
    } else if (!this.state[formattedName]) {
      // console.log(`${formattedName} is new or false`);
      // console.log(parseInt(this.state[category]));
      // console.log(parseInt(value));

      if (sessionStorage.getItem(`${category}`)) {
        this.setState({
          [category]: sessionStorage.getItem(`${category}`) + value
        });
      } else {
        this.setState({
          [category]: (this.state[category] += parseInt(value))
        });
      }

      // console.log(category);
      // console.log(parseInt(this.state[category]));
      let categoryTotal = 0;

      categoryObj = this.state[`${category}Obj`];
      // console.log("Item Created in Object");
      categoryObj[formattedName] = value;

      //KEEPS A RUNNING TOTAL OF THE ITEMS IN THE OBJECT

      for (let item in categoryObj) {
        // console.log("Inside the for loop");
        categoryTotal += parseInt(categoryObj[item]);
        // console.log(categoryTotal);
        this.setState({
          categoryTotal: categoryTotal,
          [category]: categoryTotal
        });
        sessionStorage.setItem(category, categoryTotal);
        if (categoryTotal > this.state[`${category}Max`]) {
          console.log(e.target.getAttribute("name"));
          this.setState({
            [`${category}MaxReached`]: true,
            [`${category}MaxButton`]: e.target.getAttribute("name")
          });
          sessionStorage.setItem(`${category}MaxReached`, true);
          sessionStorage.setItem(
            `${category}MaxButton`,
            e.target.getAttribute("name")
          );
        } else {
          console.log(categoryObj);
          this.setState({
            [`${category}MaxReached`]: false
          });
        }
      }

      //-----------------------------------------------//

      // console.log(typeof(sessionStorage.getItem("InformSubmitted")))
      // console.log(typeof(categoryTotal))

      if (!isNaN(parseInt(sessionStorage.getItem(`${category}Submitted`)))) {
        let newTotal =
          categoryTotal +
          parseInt(sessionStorage.getItem(`${category}Submitted`));
        this.setState({
          [category]: newTotal
        });
        sessionStorage.setItem(category, newTotal);
        // console.log("Total of running and existing: " + newTotal)
      }

      // console.log("Running Lock Check");
      await this.lockCheck();

      this.setState({
        [formattedName]: true,
        [`${category}Obj`]: categoryObj
      });
      sessionStorage.setItem(formattedName, true);
      sessionStorage.setItem(`${category}Obj`, JSON.stringify(categoryObj));
      await this.props.engagementFunc(formattedName, diff);
    }

    // this.lockCheck()

    // this.props.engagementFunc(formattedName, diff)
    console.log(sessionStorage.getItem("engageObj"));
    await sessionStorage.setItem(
      `engagement`,
      JSON.stringify({
        city_id: parseFloat(this.city_id),
        engagement: {
          currentEngagement: sessionStorage.getItem("currentEngagement"),
          totalEngagement: sessionStorage.getItem("totalEngagement"),
          Inform: sessionStorage.getItem("Inform"),
          InformTarget: this.state.InformTarget,
          InformLock: this.state.InformLock,
          InformMaxReached: sessionStorage.getItem("InformMaxReached"),
          InformObj: sessionStorage.getItem("InformObj"),
          InformSubmitted: this.state.InformSubmitted,
          Consult: sessionStorage.getItem("Consult"),
          ConsultTarget: this.state.ConsultTarget,
          ConsultLock: this.state.ConsultLock,
          ConsultDisabled: this.state.ConsultDisabled,
          ConsultMaxReached: sessionStorage.getItem("ConsultMaxReached"),
          ConsultObj: sessionStorage.getItem("ConsultObj"),
          ConsultSubmitted: this.state.ConsultSubmitted,
          Involve: sessionStorage.getItem("Involve"),
          InvolveTarget: this.state.InvolveTarget,
          InvolveLock: this.state.InvolveLock,
          InvolveDisabled: this.state.InvolveDisabled,
          InvolveMaxReached: sessionStorage.getItem("InvolveMaxReached"),
          InvolveObj: sessionStorage.getItem("InvolveObj"),
          InvolveSubmitted: this.state.InvolveSubmitted,
          Collaborate: sessionStorage.getItem("Collaborate"),
          CollaborateTarget: this.state.CollaborateTarget,
          CollaborateLock: this.state.CollaborateLock,
          CollaborateDisabled: this.state.CollaborateDisabled,
          CollaborateObj: sessionStorage.getItem("CollaborateObj"),
          CollaborateMaxReached: sessionStorage.getItem(
            "CollaborateMaxReached"
          ),
          CollaborateSubmitted: this.state.CollaborateSubmitted,
          engageObj: sessionStorage.getItem("engageObj")
        }
      })
    );
    this.runSelections()

    console.groupEnd();
  };

  onClickHandler = e => {
    console.groupCollapsed("DistrictEngagement:onClickHandler")
    e.preventDefault();
    this.setState({
      subPolicy: e.target.getAttribute("subpol")
    });

    const engagementDefaultValue = this.state.districtEngagementData.filter(
      item => item.name === e.target.getAttribute("subpol")
    )[0].defaultValue;

    if (
      sessionStorage.getItem(
        `${this.props.districtName}/${e.target.getAttribute("subpol")}`
      )
    ) {
      this.setState({
        subPolicyDefaultValue: sessionStorage.getItem(
          `${this.props.districtName}/${e.target.getAttribute("subpol")}`
        )
      });
    } else {
      this.setState({
        engagementDefaultValue: engagementDefaultValue
      });
    }
    console.groupEnd()
  };

  onSubmitHandler = async (e) => {
    console.groupCollapsed("DistrictEngagement:onSubmitHandler")
    e.preventDefault();
    
    sessionStorage.setItem(
      `engagement`,
      JSON.stringify({
        city_id: parseFloat(this.city_id),
        engagement: {
          currentEngagement: sessionStorage.getItem("currentEngagement"),
          totalEngagement: sessionStorage.getItem("currentEngagement"),
          Inform: sessionStorage.getItem("Inform"),
          InformTarget: this.state.InformTarget,
          InformLock: this.state.InformLock,
          InformMaxReached: sessionStorage.getItem("InformMaxReached"),
          InformObj: sessionStorage.getItem("InformObj"),
          InformSubmitted: this.props.InformSubmitted,
          Consult: sessionStorage.getItem("Consult"),
          ConsultTarget: this.state.ConsultTarget,
          ConsultLock: this.state.ConsultLock,
          ConsultDisabled: this.state.ConsultDisabled,
          ConsultMaxReached: sessionStorage.getItem("ConsultMaxReached"),
          ConsultObj: sessionStorage.getItem("ConsultObj"),
          ConsultSubmitted: this.state.ConsultSubmitted,
          Involve: sessionStorage.getItem("Involve"),
          InvolveTarget: this.state.InvolveTarget,
          InvolveLock: this.state.InvolveLock,
          InvolveDisabled: this.state.InvolveDisabled,
          InvolveMaxReached: sessionStorage.getItem("InvolveMaxReached"),
          InvolveObj: sessionStorage.getItem("InvolveObj"),
          InvolveSubmitted: this.state.InvolveSubmitted,
          Collaborate: sessionStorage.getItem("Collaborate"),
          CollaborateTarget: this.state.CollaborateTarget,
          CollaborateLock: this.state.CollaborateLock,
          CollaborateDisabled: this.state.CollaborateDisabled,
          CollaborateObj: sessionStorage.getItem("CollaborateObj"),
          CollaborateMaxReached: sessionStorage.getItem(
            "CollaborateMaxReached"
          ),
          CollaborateSubmitted: this.state.CollaborateSubmitted,
          engageObj: sessionStorage.getItem("engageObj")
        }
      })
    );

     await this.props.setTotalEngagement();
     const moses_gulch = JSON.parse(sessionStorage.getItem("Moses Gulch"));
     const downtown = JSON.parse(sessionStorage.getItem("Downtown"));
     const jacobs_hill = JSON.parse(sessionStorage.getItem("Jacobs Hill"));
     const howard_gardens = JSON.parse(
       sessionStorage.getItem("Howard Gardens")
     );
     const corbusville = JSON.parse(sessionStorage.getItem("Corbusville"));
     const city = JSON.parse(sessionStorage.getItem("City"));
     const engagement = JSON.parse(sessionStorage.getItem("engagement"));
     let sectorsArray = [
        moses_gulch,
        downtown,
        jacobs_hill,
        howard_gardens,
        corbusville,
        city,
        engagement
      ];
      let validSectorsArray = [];

      for (let i = 0; i < sectorsArray.length; i++) {
        if (sectorsArray[i]) {
          validSectorsArray.push(sectorsArray[i]);
        }
      }

      await axios
        .post(this.fetchURL + "/api/v1/policies/submissions/", {
          city_id: this.city_id,
          sector_name: "City",
          pollist: this.state.selections,
          varsObj: { CxCityHolderVal: 0 },
          submitObject: validSectorsArray
        })
        .then(response => {
          this.setState({ startRequestSent: false });
          if (response.data.success) {
            console.group("Policy Submissions Test");
            console.log("Test Successfull!");
            console.log(response.data.data);
            this.props.onsubmitSyncToClients()
            console.groupEnd();
          }
        })
        //     this.setState({
        //       snackOpen: true,
        //       snackMsg: response.data.message,
        //       snackType: "snack-success",
        //       snackAutoHideDuration: 5000
        //     });

        //     // added to update objectives after starting the scenario
        //     window.location.reload();
        //   } else {
        //     console.log(response.data.message);
        //     this.setState({
        //       snackOpen: true,
        //       snackMsg: response.data.message,
        //       snackType: "snack-error",
        //       snackAutoHideDuration: null
        //     });
        //   }
        // })
        .catch(error => {
          console.log(error.response);
          // this.setState({ startRequestSent: false });
          // this.setState({
          //   snackOpen: true,
          //   snackMsg: "Something went wrong. Please try again later.",
          //   snackType: "snack-error",
          //   snackAutoHideDuration: 5000
          // });
        });
      console.groupEnd();
      // axios
      //   .post(this.fetchURL + "/api/v1/selections/", {
      //     selections: sessionStorage,
      //     city_name: this.city_name
      //   })
      //   .then(response => {
      //     this.setState({ startRequestSent: false });
      //     if (response.data.success) {
      //       console.group("Selections Routing Test Started");
      //       console.log("Test Successfull!");
      //       console.log(response.data.data);
      //       console.groupEnd();
      //     }
      //   })
      //   //     this.setState({
      //   //       snackOpen: true,
      //   //       snackMsg: response.data.message,
      //   //       snackType: "snack-success",
      //   //       snackAutoHideDuration: 5000
      //   //     });

      //   //     // added to update objectives after starting the scenario
      //   //     window.location.reload();
      //   //   } else {
      //   //     console.log(response.data.message);
      //   //     this.setState({
      //   //       snackOpen: true,
      //   //       snackMsg: response.data.message,
      //   //       snackType: "snack-error",
      //   //       snackAutoHideDuration: null
      //   //     });
      //   //   }
      //   // })
      //   .catch(error => {
      //     console.log(error.response);
      //     this.setState({ startRequestSent: false });
      //     this.setState({
      //       snackOpen: true,
      //       snackMsg: "Something went wrong. Please try again later.",
      //       snackType: "snack-error",
      //       snackAutoHideDuration: 5000
      //     });
      //   });
      console.groupEnd();
    }
  


  render() {
    let engagementDescription = this.state.districtEngagementData.filter(
      item => item.name === this.props.engagementSubPolicy
    );
    // console.log(engagementDescription[0]);
    // console.log(this.state)
    // console.log(this.state.subPolicy)
    // console.log(this.state.Inform)
    // console.log(this.state.InformMaxReached)
    // console.log(this.state.suspendButton)
    // console.log(this.props.utilizing_social_media)
    let subPolicy = this.props.engagementSubPolicy;
    return (
      <div className="engagementPolicyPanel" style={this.props.districtName === "Downtown" ? {backgroundImage: `url(${downtownImage})`} : this.props.districtName === "Jacobs Hill" ? {backgroundImage: `url(${jacobsHillImage})`} : this.props.districtName === "Moses Gulch" ? {backgroundImage: `url(${mosesGulchImage})`} : this.props.districtName === "Corbusville" ? {backgroundImage: `url(${corbusvileImage})`} : this.props.districtName === "Howard Gardens" ? {backgroundImage: `url(${howardGardensImage})`} : null}>
        <div className="frostyBox" style={{ padding: "10px" }}>
        <div className="engagementPolicySelection flex flex-90-10">
          <div className="policySelectionHeading">
            {this.props.policyHeader}{" "}
            <span style={{ color: "#FF6302" }}> > </span> {this.props.engagementSubPolicy}
          </div>
          {this.student_is_manager === "true" ? (
                  <button
                    className={
                      this.props.suspendButton === true || this.props.engagementSuspended === true
                        ? "submitSuspended"
                        : "citySubmit"
                    }
                    onClick={e => this.props.engagementSubmitPrevent(e)}
                  >
                    {this.props.suspendButton === true || this.props.engagementSuspended === true ? "Suspended" : "Submit"}
                  </button>
              ) : null}
        </div>
        
        <div className="subPolicySelection flex flex-30-70">
          <div className="subPolicy">
            {this.props.districtEngagementData.map((item, index) => (
              <div className="flex flex-auto" key={index}>
                {this.props.engagementSubPolicy === item.name ? (
                  <span style={{ color: "#5399C9" }}>{"\u2B24"}</span>
                ) : (
                  <span style={{ color: "rgba(255, 0, 0, 0)" }}>{"\u2B24"}</span>
                )}
                <h1
                  key={index}
                  onClick={e => this.props.onEngagementClickHandler(e)}
                  subpol={item.name}
                  disabled={this.props[`${item.name}Disabled`]}
                >
                  {item.name} {"("}
                  {this.props[item.name]}
                  {"/"}
                  {this.props[`${item.name}Target`]}
                  {")"}{" "}
                  {this.props[`${item.name}Lock`] === true  && this.student_is_manager === "true" ? (
                    <FontAwesomeIcon
                      icon={["fas", "lock"]}
                      style={{ color: "#5399C9" }}
                    />
                  ) : null}
                </h1>
              </div>
            ))}
          </div>
          <div className="policyDescription">
            {engagementDescription[0] ? (
              engagementDescription[0].description.map((item, index) => (
                <h1 key={index}>{item}</h1>
              ))
            ) : (
              <h1>Please Select Engagement Category</h1>
            )}
            <div
              className={this.props.disabledButton || this.props.engagementSuspended ? "disabledButton flex flex-items-center flex-wrap" :
                !this.props[`${this.props.engagementSubPolicy}Lock`]
                  ? "flex flex-items-center flex-wrap"
                  : "disabledButton flex flex-items-center flex-wrap"
              }
            >
              {engagementDescription[0]
                ? Object.values(engagementDescription[0].parameters).map(
                    (item, index) => (
                      <button
                        className={
                          this.props[
                            `${item.name.replace(/ /g, "_").toLowerCase()}`
                          ]
                            ? "toggled"
                            : "selectParameter"
                        }
                        style={
                          this.props[`${this.props.engagementSubPolicy}MaxButton`] ===
                          item.name
                            ? { borderColor: "red" }
                            : { borderColor: "#9cb1c4" }
                        }
                        onClick={e => this.props.onEngagementSelectHandler(e)}
                        key={index}
                        paranumber={index + 1}
                        year={this.props.currentYear}
                        nameCheck={item.name.replace(/ /g, "_").toLowerCase()}
                        engageval={item.engageVal}
                        value={index + 1}
                        name={item.name}
                        disabled={this.props.disabledButton || this.props.engagementSuspended}
                      >
                        {item.name}
                        {/* {" + "}
                        {item.engageVal}{" "} */}
                      </button>
                    )
                  )
                : null}
              <div className="engagementWarning" style={{ color: "red" }}>
                {this.props[`${subPolicy}MaxReached`]
                  ? `Please select no more than ${
                      this.props[`${subPolicy}Max`]
                    } Engagement Points. Submissions are now suspended.`
                  : null}
                  {this.props.engagementSuspended === true ? "Please wait until the game has advanced to choose another Community Engagement policy." : null}
              </div>
            </div>
          </div>
        </div>
        </div>
      </div>
    );
  }
}

export default withRouter(DistrictEngagement);
